<template>
  <path pid="0" d="M12.39 2.21l-9 7A1 1 0 003 10v11a3 3 0 003 3h14a3 3 0 003-3V10a1 1 0 00-.39-.79l-9-7a1 1 0 00-1.22 0zM15 22h-4v-8h4zm6-1a1 1 0 01-1 1h-3v-9a1 1 0 00-1-1H9.88A1 1 0 009 13v9H6a1 1 0 01-1-1V10.49l8-6.22 8 6.22z"/>
</template>
